import { EAmenity } from "@/@types/dtos/amenities.types";

export const AMENITIES_KEYS: Record<EAmenity, string> = {
  [EAmenity.atm]: 'Caixa eletrónico',
  [EAmenity.bathroom]: 'Banheiro',
  [EAmenity.coffe_shop]: 'Cafeteria',
  [EAmenity.restaurant]: 'Restaurante',
  [EAmenity.pharmacy]: 'Farmácia',
  [EAmenity.wifi]: 'Wifi',
  [EAmenity.shopping]: 'Shopping'
}
export class Amenity {
  id: EAmenity;
  name: string;
  constructor(data: string) {
    this.id = data as EAmenity
    this.name = AMENITIES_KEYS[this.id]
  }
}
